import Big from 'big.js';
import axios from 'smg/axios';
import { Start } from 'smg/buttons';
import { GetPriceByArea } from 'smg/customer-api/lineitems';
import * as models from 'smg/customer-api/models';
import { ShowError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import * as html from 'smg/html';
import { GetWidthHeightFromSize } from 'smg/lineitemtypesizes';
import { DollarFormat } from 'smg/util';
import { ForgetCalculatorPicks, LoadCalculatorPicks } from '../../free-quote/calculator-picks';
import * as sidebar from '../../free-quote/sidebar';
import * as store from '../../free-quote/store';
import { Relref } from '../../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
    readonly product: string;
}
declare const window: myWindow;

void main();

async function main() {
    store.Init();

    const settings = store.Get();
    if (!settings.getStarted || !settings.details || !settings.upload) {
        store.Redirect();
        return;
    }

    const $form = document.querySelector('#free-quote-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $types = document.querySelectorAll<HTMLInputElement>('[name="free-quote-type"]');
    const $typesTitle = $types[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');

    const $platings = document.querySelectorAll<HTMLInputElement>('[name="free-quote-plating"]');
    const $platingTitle = $platings[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');

    const $finishes = document.querySelectorAll<HTMLInputElement>('[name="free-quote-finish"]');
    const $finishTitle = $finishes[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');

    const $edges = document.querySelectorAll<HTMLInputElement>('[name="free-quote-edge"]');
    const $edgesTitle = $edges[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');

    const $attachments = document.querySelectorAll<HTMLInputElement>('[name="free-quote-attachment"]');
    const $attachmentsTitle = $attachments[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');

    const $accessories = document.querySelectorAll<HTMLInputElement>('[name="free-quote-accessory"]');
    const $accessoriesTitle = $accessories[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');
    const $accessoriesSkip = document.querySelector<HTMLElement>('#free-quote-accessory-skip');

    const $features = document.querySelectorAll<HTMLInputElement>('[name="free-quote-feature"]');
    const $featuresTitle = $features[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');
    const $featuresSkip = document.querySelector<HTMLElement>('#free-quote-feature-skip');

    const $packagings = document.querySelectorAll<HTMLInputElement>('[name="free-quote-packaging"]');
    const $packagingTitle = $packagings[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');

    const $upgrades = document.querySelectorAll<HTMLInputElement>('[name="free-quote-upgrade"]');
    const $upgradesTitle = $upgrades[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');
    const $upgradesSkip = document.querySelector<HTMLElement>('#free-quote-upgrade-skip');

    const $locations = document.querySelectorAll<HTMLInputElement>('[name="free-quote-location"]');
    const $locationsTitle = $locations[0]?.closest('.free-quote-option-parent')?.querySelector('.free-quote-option-selection');

    const $coin3DMoldUpgrade = document.querySelector<HTMLInputElement>('input[name="free-quote-upgrade"][value="3D Molds"]') as HTMLInputElement;

    const $typesParent = document.querySelector<HTMLElement>('#free-quote-type-options-parent');
    if (window.product === 'Lapel Pin' && settings.details.color !== 'yes') {
        $typesParent?.remove();

        const $optionsIndexes = document.querySelectorAll<HTMLElement>('.free-quote-options-parent-index');
        let i = 1;
        $optionsIndexes.forEach($index => {
            $index.textContent = i.toLocaleString(); // kek
            i++;
        });
    } else {
        void (async () => {
            const $typePrices = $typesParent?.querySelectorAll<HTMLElement>('.free-quote-type-additional-price');
            if (!$typePrices) {
                return;
            }

            let min: Big | undefined;

            const prices = new Map<string, Big>();

            for (const $price of Array.from($typePrices)) {
                const type = $price.closest('.option-card')?.querySelector<HTMLInputElement>('[name="free-quote-type"]')?.value;
                const price = await GetPriceByArea(window.product, type ?? '', store.Width() ?? 0, store.Height() ?? 0, store.Quantity());
                prices.set(type ?? '', price);

                if (!min || price.lt(min)) {
                    min = price;
                }
            }

            for (const $price of Array.from($typePrices)) {
                const type = $price.closest('.option-card')?.querySelector<HTMLInputElement>('[name="free-quote-type"]')?.value;
                const price = prices.get(type ?? '');

                if (price && min && price.eq(min)) {
                    if (!$price.hasAttribute('data-free')) {
                        $price.textContent = 'Included';
                    } else {
                        $price.textContent = $price.getAttribute('data-free');
                    }
                } else {
                    $price.textContent = ($price.getAttribute('data-template') ?? '').replace('$', DollarFormat((price ?? Big(0)).sub(min ?? Big(0))));
                }
            }
        })();

        const $continue = document.querySelector<HTMLElement>('#free-quote-type-continue');
        $continue?.addEventListener('click', () => {
            $typesParent?.querySelector(':checked')?.dispatchEvent(new Event('click'));
            $typesTitle?.dispatchEvent(new Event('click'));
        });
    }

    const updateSubmit = () => {
        sidebar.$submit.disabled = !$form.checkValidity();
    };

    const type = (): { name: string; lineItemTypeID: models.LineItemTypeID | undefined } => {
        if (window.product === 'Lapel Pin') {
            if (settings.details?.color === 'yes') {
                const $type = Array.from($types).find($type => $type.checked);
                if ($type) {
                    return { name: $type.value, lineItemTypeID: $type.getAttribute('data-line-item-type-id') as models.LineItemTypeID };
                }
            }

            return store.Type();
        } else if (window.product === 'Patch' || window.product === 'Lanyard') {
            const $type = Array.from($types).find($type => $type.checked);
            if ($type) {
                return { name: $type.value, lineItemTypeID: $type.getAttribute('data-line-item-type-id') as models.LineItemTypeID };
            }
        }

        return store.Type();
    };

    const getMoldFees = async (): Promise<{ baseMoldFee: Big; moldFee3D: Big }> => {
        const s = store.Size();
        if (!s) {
            return { baseMoldFee: Big(0), moldFee3D: Big(0) };
        }

        const { width, height } = GetWidthHeightFromSize(s);

        const { lineItemTypeID } = type();

        const sizesResp = await axios.get('/line-item-type-sizes', {
            params: {
                'q': `lineItem:"${window.product}" lineItemTypeID:"${lineItemTypeID ?? ''}" width:${width} ${height !== width ? `height:${height}` : ''} type:"",null`,
                'data': 'id',
            },
        });
        const sizesData = models.LineItemTypeSizesHyejooResponse.fromJSON(sizesResp.data);
        const lineItemTypeSizeID = sizesData.lineItemTypeSizes[0]?.id;

        let baseMoldFee = Big(0);
        let moldFee3D = Big(0);

        try {
            const childResp = await axios.get('/child-line-items', {
                params: {
                    'q': `lineItem:"${window.product}" mold:yes`,
                    'data': 'lineItemID,networkChildLineItem,childLineItemOptions,name,pluralName',
                    'width': width,
                    'height': height,
                    'quantity': store.Quantity(),
                    'lineItemTypeID': lineItemTypeID,
                    'lineItemTypeSizeID': lineItemTypeSizeID,
                },
            });
            const data = models.ChildLineItemsHyejooResponse.fromJSON(childResp.data);
            for (const childLineItem of data.childLineItems) {
                if (childLineItem.id === models.ChildLineItemID.CHILD_LINE_ITEM_PIN_MOLD_FEE) {
                    baseMoldFee = childLineItem.networkChildLineItem?.price ?? Big(0);
                }

                for (const childLineItemOption of childLineItem.childLineItemOptions) {
                    if (childLineItemOption.id === models.ChildLineItemOptionID.CHILD_LINE_ITEM_OPTION_COIN_MOLD_FEE_NEW_BOTH_SIDES) {
                        baseMoldFee = childLineItemOption.networkChildLineItemOption?.price ?? Big(0);
                    }
                    if (childLineItemOption.id === models.ChildLineItemOptionID.CHILD_LINE_ITEM_OPTION_COIN_3_D_MOLD_FEE_NEW_ONE_SIDE) {
                        moldFee3D = childLineItemOption.networkChildLineItemOption?.price ?? Big(0);
                    }
                }
            }
        } catch (err) {
            ShowError(err);
            throw err;
        }

        return { baseMoldFee, moldFee3D };
    };

    const { baseMoldFee, moldFee3D } = await getMoldFees();

    if (window.product === 'Challenge Coin' && !moldFee3D.eq(0) && $coin3DMoldUpgrade) {
        const $price = html.FromString(`<div
            class="text-muted small child-line-item-option-price text-center fst-italic mt-auto option-price-mold"
            data-price="${moldFee3D.toString()}"
        >${DollarFormat(moldFee3D)} fee</div>`);
        $coin3DMoldUpgrade.parentElement?.insertBefore($price, $coin3DMoldUpgrade.parentElement.querySelector('.child-line-item-option-price'));
    }

    const updateSidebar = async () => {
        const { name: typeName } = type();
        const sizeName = store.Size();
        const qty = store.Quantity();

        if (!sizeName || !qty) {
            return;
        }

        if (qty) {
            sidebar.$sidebarQty.textContent = Intl.NumberFormat().format(qty);
        } else {
            sidebar.$sidebarQty.textContent = 'TBD';
        }

        let price = await GetPriceByArea(window.product, typeName, store.Width() ?? 0, store.Height() ?? 0, store.Quantity());
        if (price.eq(0)) {
            sidebar.$sidebarUnitPrice.textContent = 'TBD';
        } else {
            price = price.add(getPriceFromRadios($types));
            price = price.add(getPriceFromRadios($platings));
            price = price.add(getPriceFromRadios($finishes));
            price = price.add(getPriceFromRadios($edges));
            price = price.add(getPriceFromRadios($attachments));
            price = price.add(getPriceFromRadios($accessories));
            price = price.add(getPriceFromRadios($features));
            price = price.add(getPriceFromRadios($packagings));
            price = price.add(getPriceFromRadios($upgrades));
            price = price.add(await store.ChildrenTotalUnitPrice());

            sidebar.$sidebarUnitPrice.textContent = DollarFormat(price);
        }

        let moldFee = baseMoldFee.plus(getMoldPriceFromRadios($types));
        moldFee = moldFee.plus(getMoldPriceFromRadios($upgrades));
        sidebar.$sidebarMoldFee.textContent = DollarFormat(moldFee);

        if (price.eq(0)) {
            sidebar.$sidebarTotal.textContent = 'TBD';
        } else {
            price = price.times(store.Quantity()).plus(moldFee);
            sidebar.$sidebarTotal.textContent = DollarFormat(price);
        }
    };

    void updateSidebar();

    const getPriceFromRadios = ($radios: NodeListOf<HTMLInputElement>): Big => {
        const $option = Array.from($radios).find($radio => !$radio.classList.contains('option-price-mold') && $radio.checked)?.closest('.option-card');
        if (!$option) {
            return Big(0);
        }

        const $price = $option.querySelector<HTMLElement>('.child-line-item-option-price:not(.option-price-mold),.child-line-item-price:not(.option-price-mold)');
        if (!$price) {
            return Big(0);
        }

        const price = $price.getAttribute('data-price');
        if (!price) {
            return Big(0);
        }

        return Big(price);
    };

    const getMoldPriceFromRadios = ($radios: NodeListOf<HTMLInputElement>): Big => {
        const $radio = Array.from($radios).find($radio => $radio.checked);
        if (!$radio) {
            return Big(0);
        }

        const $option = $radio?.closest('.option-card');
        if (!$option) {
            return Big(0);
        }

        let $price: HTMLElement | null;
        if ($radio.classList.contains('option-price-mold')) {
            $price = $option.querySelector<HTMLElement>('.child-line-item-option-price,.child-line-item-price');
        } else {
            $price = $option.querySelector<HTMLElement>('.child-line-item-option-price.option-price-mold,.child-line-item-price.option-price-mold');
        }
        if (!$price) {
            return Big(0);
        }

        const price = $price.getAttribute('data-price');
        if (!price) {
            return Big(0);
        }

        return Big(price);
    };

    let prevType = '';
    $types.forEach($type => {
        $type.addEventListener('click', () => {
            if ($typesTitle) {
                $typesTitle.textContent = $type.value;
                $typesTitle.parentElement?.classList.remove('d-none');

                if (!prevType && settingsLoaded) {
                    $typesTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevType = $type.value;
        });
    });

    const { lineItemTypeID } = type();

    let prevPlating = '';
    $platings.forEach($plating => {
        const requires = $plating.getAttribute('data-requires');
        const requiresNot = $plating.getAttribute('data-requires-not');
        if (lineItemTypeID && ((requires && !requires.includes(lineItemTypeID)) || requiresNot?.includes(lineItemTypeID))) {
            $plating.closest('label')?.classList.add('d-none');
            if (settings.inDepth?.plating === $plating.value) {
                settings.inDepth.plating = '';
                sidebar.SetPlating('');
            }
        }
        $plating.addEventListener('click', () => {
            sidebar.SetPlating($plating.value);

            if ($platingTitle) {
                $platingTitle.textContent = $plating.value;
                $platingTitle.parentElement?.classList.remove('d-none');

                if (!prevPlating && settingsLoaded) {
                    $platingTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevPlating = $plating.value;
        });
    });
    if (Array.from($platings).find($plating => $plating.closest('label')?.classList.contains('d-none'))) {
        sidebar.SetPlating(Array.from($platings).find($plating => !$plating.closest('label')?.classList.contains('d-none'))?.value || '');
    }

    let prevFinish = '';
    $finishes.forEach($finish => {
        const requires = $finish.getAttribute('data-requires');
        const requiresNot = $finish.getAttribute('data-requires-not');
        if (lineItemTypeID && ((requires && !requires.includes(lineItemTypeID)) || requiresNot?.includes(lineItemTypeID))) {
            $finish.closest('label')?.classList.add('d-none');
            if (settings.inDepth?.finish === $finish.value) {
                settings.inDepth.plating = '';
                settings.inDepth.finish = '';
                sidebar.SetPlating('');
            }
        }
        $finish.addEventListener('click', () => {
            sidebar.SetPlating($finish.value);

            if ($finishTitle) {
                $finishTitle.textContent = $finish.value;
                $finishTitle.parentElement?.classList.remove('d-none');

                if (!prevFinish && settingsLoaded) {
                    $finishTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevFinish = $finish.value;
        });
    });
    if (Array.from($finishes).find($finish => $finish.closest('label')?.classList.contains('d-none'))) {
        sidebar.SetPlating(Array.from($finishes).find($finish => !$finish.closest('label')?.classList.contains('d-none'))?.value || '');
    }

    let prevEdge = '';
    $edges.forEach($edge => {
        $edge.addEventListener('click', () => {
            if ($edgesTitle) {
                $edgesTitle.textContent = $edge.value;
                $edgesTitle.parentElement?.classList.remove('d-none');

                if (!prevEdge && settingsLoaded) {
                    $edgesTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevEdge = $edge.value;
        });
    });

    let prevAttachment = '';
    $attachments.forEach($attachment => {
        $attachment.addEventListener('click', () => {
            if ($attachmentsTitle) {
                $attachmentsTitle.textContent = $attachment.value;
                $attachmentsTitle.parentElement?.classList.remove('d-none');

                if (!prevAttachment && settingsLoaded) {
                    $attachmentsTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevAttachment = $attachment.value;
        });
    });

    let prevAccessory = '';
    $accessories.forEach($accessory => {
        $accessory.addEventListener('click', () => {
            if ($accessoriesTitle) {
                $accessoriesTitle.textContent = $accessory.value;
                $accessoriesTitle.parentElement?.classList.remove('d-none');

                if (!prevAccessory && settingsLoaded) {
                    $accessoriesTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevAccessory = $accessory.value;
        });
    });

    $accessoriesSkip?.addEventListener('click', () => {
        $accessoriesTitle?.dispatchEvent(new Event('click'));
    });

    let prevFeature = '';
    $features.forEach($feature => {
        $feature.addEventListener('click', () => {
            if ($featuresTitle) {
                $featuresTitle.textContent = $feature.value;
                $featuresTitle.parentElement?.classList.remove('d-none');

                if (!prevFeature && settingsLoaded) {
                    $featuresTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevFeature = $feature.value;
        });
    });

    $featuresSkip?.addEventListener('click', () => {
        $featuresTitle?.dispatchEvent(new Event('click'));
    });

    let prevPackaging = '';
    $packagings.forEach($packaging => {
        $packaging.addEventListener('click', () => {
            if ($packagingTitle) {
                $packagingTitle.textContent = $packaging.value;
                $packagingTitle.parentElement?.classList.remove('d-none');

                if (!prevPackaging && settingsLoaded) {
                    $packagingTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevPackaging = $packaging.value;
        });
    });

    let prevUpgrade = '';
    $upgrades.forEach($upgrade => {
        $upgrade.addEventListener('click', () => {
            sidebar.$previewEnamel?.classList.add('d-none');
            sidebar.$previewTranslucent?.classList.add('d-none');
            sidebar.$previewGlitter?.classList.add('d-none');

            sidebar.SetUpgrade($upgrade.value, settings.details?.color || '');

            if ($upgradesTitle) {
                $upgradesTitle.textContent = $upgrade.value;
                $upgradesTitle.parentElement?.classList.remove('d-none');

                if (!prevUpgrade && settingsLoaded) {
                    $upgradesTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevUpgrade = $upgrade.value;
        });
    });
    const $upgradesParent = $upgrades[0]?.closest('.free-quote-option-parent');
    const $upgradesCollapse = $upgradesParent?.querySelector('[data-bs-toggle="collapse"]');
    const $upgradesRequires = $upgradesCollapse?.getAttribute('data-requires');
    const $upgradesRequiresNot = $upgradesCollapse?.getAttribute('data-requires-not');
    if (lineItemTypeID && $upgradesRequires && !$upgradesRequires.includes(lineItemTypeID)) {
        $upgradesParent?.classList.add('d-none');
        $upgrades.forEach($upgrade => $upgrade.required = false);
    }
    if (lineItemTypeID && $upgradesRequiresNot?.includes(lineItemTypeID)) {
        $upgradesParent?.classList.add('d-none');
        $upgrades.forEach($upgrade => $upgrade.required = false);
    }

    if (settings.details?.color) {
        sidebar.SetUpgrade('', settings.details?.color);
    }

    $upgradesSkip?.addEventListener('click', () => {
        $upgradesTitle?.dispatchEvent(new Event('click'));
    });

    let prevLocation = '';
    $locations.forEach($location => {
        $location.addEventListener('click', () => {
            if ($locationsTitle) {
                $locationsTitle.textContent = $location.value;
                $locationsTitle.parentElement?.classList.remove('d-none');

                if (!prevLocation && settingsLoaded) {
                    $locationsTitle.dispatchEvent(new Event('click'));
                }
            }

            updateSubmit();
            void updateSidebar();

            prevLocation = $location.value;
        });
    });

    let settingsLoaded = false;
    if (settings.inDepth) {
        if (settings.inDepth.type) {
            const $type = Array.from($types).find($type => $type.value === settings.inDepth?.type);
            if ($type) {
                $type.click();
                $type.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.plating) {
            const $plating = Array.from($platings).find($plating => $plating.value === settings.inDepth?.plating);
            if ($plating) {
                $plating.click();
                $plating.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.finish) {
            const $finish = Array.from($finishes).find($finish => $finish.value === settings.inDepth?.finish);
            if ($finish) {
                $finish.click();
                $finish.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.edge) {
            const $edge = Array.from($edges).find($edge => $edge.value === settings.inDepth?.edge);
            if ($edge) {
                $edge.click();
                $edge.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.attachment) {
            const $attachment = Array.from($attachments).find($attachment => $attachment.value === settings.inDepth?.attachment);
            if ($attachment) {
                $attachment.click();
                $attachment.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.accessory) {
            const $accessory = Array.from($accessories).find($accessory => $accessory.value === settings.inDepth?.accessory);
            if ($accessory) {
                $accessory.click();
                $accessory.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.feature) {
            const $feature = Array.from($features).find($feature => $feature.value === settings.inDepth?.feature);
            if ($feature) {
                $feature.click();
                $feature.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.packaging) {
            const $packaging = Array.from($packagings).find($packaging => $packaging.value === settings.inDepth?.packaging);
            if ($packaging) {
                $packaging.click();
                $packaging.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.upgrade) {
            const $upgrade = Array.from($upgrades).find($upgrade => $upgrade.value === settings.inDepth?.upgrade);
            if ($upgrade) {
                $upgrade.click();
                $upgrade.dispatchEvent(new Event('click'));
            }
        }

        if (settings.inDepth.location) {
            const $location = Array.from($locations).find($location => $location.value === settings.inDepth?.location);
            if ($location) {
                $location.click();
                $location.dispatchEvent(new Event('click'));
            }
        }
    }

    // The product page's calculator style wins over a saved type: the visitor chose it last.
    const { type: pickedType } = LoadCalculatorPicks();
    const $pickedType = pickedType ? Array.from($types).find($type => $type.value === pickedType && !$type.disabled) : undefined;
    $pickedType?.click();
    settingsLoaded = true;

    sidebar.$submit.addEventListener('click', () => {
        if (!ReportValidity($form)) {
            return;
        }

        Start(sidebar.$submit);
        $fieldset.disabled = true;

        const settings = store.Get();
        settings.inDepth = {
            type: Array.from($types).find($type => $type.checked)?.value || '',
            lineItemTypeID: Array.from($types).find($type => $type.checked)?.getAttribute('data-line-item-type-id') as models.LineItemTypeID || '',
            plating: Array.from($platings).find($plating => $plating.checked)?.value || '',
            finish: Array.from($finishes).find($finish => $finish.checked)?.value || '',
            edge: Array.from($edges).find($edge => $edge.checked)?.value || '',
            attachment: Array.from($attachments).find($attachment => $attachment.checked)?.value || '',
            accessory: Array.from($accessories).find($accessory => $accessory.checked)?.value || '',
            feature: Array.from($features).find($feature => $feature.checked)?.value || '',
            packaging: Array.from($packagings).find($packaging => $packaging.checked)?.value || '',
            upgrade: Array.from($upgrades).find($upgrade => $upgrade.checked)?.value || '',
            location: Array.from($locations).find($location => $location.checked)?.value || '',

            unitPrice: sidebar.$sidebarUnitPrice?.textContent || '',
            moldFee: sidebar.$sidebarMoldFee?.textContent || '',
            total: sidebar.$sidebarTotal?.textContent || '',
        };
        store.Set(settings);
        ForgetCalculatorPicks('type');

        if (window.location.href.includes('american-made')) {
            window.location.href = Relref('/american-made-free-quote/review');
        } else {
            window.location.href = Relref('/free-quote/review');
        }
    });

    const $spinner = document.querySelector('#free-quote-spinner-parent') as HTMLElement;
    const $content = document.querySelector('#free-quote-content') as HTMLElement;
    $spinner.remove();
    $content.classList.remove('d-none');
}
